import store, { type RootState } from 'app/store';
import { showMessage } from 'app/store/fuse/messageSlice';
import config from '@/config.json';

import { axiosPrivate } from './index';

async function createAccess(pharmacyId?: string): Promise<{ access_id: string }> {
  const response = await axiosPrivate.post('/access', {
    pharmacy_id: pharmacyId,
  });

  if (!response.data.data || !response.data.data.access_id) throw new Error('Response malformed');
  return response.data.data;
}

// Mirrors connect-v1's navigateToConnectV2: create a one-time access grant for the
// current session, then hand the pharmacist off to connect-v1 with the opaque
// access_id so it can establish its own session (access + refresh tokens).
export default async function navigateToConnectV1(path: string): Promise<void> {
  const { selectedPharmacy } = (store.getState() as RootState).pharmacySelector;
  const pharmacyId =
    selectedPharmacy?._id ?? localStorage.getItem('selected_pharmacy_id') ?? undefined;
  const separator = path.includes('?') ? '&' : '?';

  try {
    const { access_id: accessId } = await createAccess(pharmacyId);
    window.location.assign(`${config.connectV1Url}${path}${separator}access_id=${accessId}`);
  } catch {
    // Callers fire-and-forget, so swallow the rejection here and tell the user the
    // hand-off failed rather than leaving them on the page with no feedback.
    store.dispatch(showMessage({ message: 'Could not open the page. Please try again.', variant: 'error' }));
  }
}
